import React from "react";
import "./App.css";
import Navbar from "./components/Navbar";
import {BrowserRouter as Router, Routes, Route} from "react-router-dom";
import Information from "./pages/information";
import Help from "./pages/help";
import Chatbot from "./pages/chatbot";
import PrivateRoute from "./components/PrivateRoute";
import AdminRoute from "./components/AdminRoute";
import About from "./pages/about";
import Login from "./pages/login";
import AdminLogin from "./pages/admin-login";
import Faq from "./pages/faq";
import Logo from "./images/mcmasterLogo.png";
import Admin from "./pages/admin";
import NewUser from "./pages/newUser";
import FAB from "./components/FAB";

function App() {
    return (
        <Router>
            <div className = "inline-header">
              <div className = "logo">
                <img src={Logo} alt="McMaster Logo" height="70" />
              </div>
              <div className = "title">
                <h1> ENT Chatbot </h1>
              </div>
            </div>
            <Navbar />
            <FAB />
            <Routes>
                <Route 
                  path="/" 
                  element={
                    <PrivateRoute>
                      <Chatbot />
                    </PrivateRoute>
                  } 
                />
                <Route path="/information" element={<Information />} />
                <Route 
                  path="/chatbot" 
                  element={
                    <PrivateRoute>
                      <Chatbot />
                    </PrivateRoute>
                  } 
                />
                <Route path="/help" element={<Help />} />
                <Route path="/about" element={<About />} />
                <Route path="/login" element={<Login />} />
                <Route path="/admin-login" element={<AdminLogin />} />
                <Route path="/newUser" element={<NewUser />} />
                <Route path="/faq" element={<Faq />} />
                <Route 
                  path="/admin" 
                  element={
                    <AdminRoute>
                      <Admin />
                    </AdminRoute>
                  } 
                />
            </Routes>
        </Router>
    );
}

export default App;